// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"spin-animation_wrapper__EuHcr","icon":"spin-animation_icon__vp_aM"};